module.exports = __webpack_public_path__ + "img/eyes-05.c7ef50bf.svg";